import { useState, useEffect } from 'react';
import { apiFetch } from '../../utils/api';
import { Loader2 } from 'lucide-react';

const DashboardStats: React.FC = () => {
    const [stats, setStats] = useState({
        total_projects: 0,
        total_leads: 0,
        total_accounts: 0,
        total_users: 0,
        pipeline_value: 0,
        monthly_expenses: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            try {
                const res = await apiFetch('/dashboard/stats');
                if (res.ok) {
                    const data = await res.json();
                    setStats(data);
                }
            } catch (error) {
                console.error("Error fetching dashboard stats", error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    if (loading) return <div className="flex justify-center p-8"><Loader2 className="animate-spin text-blue-500" /></div>;

    const cards = [
        { title: 'Total Projects', value: stats.total_projects, color: 'blue' },
        { title: 'New Leads', value: stats.total_leads, color: 'emerald' },
        { title: 'Active Accounts', value: stats.total_accounts, color: 'amber' },
        { title: 'System Users', value: stats.total_users, color: 'indigo' },
        { title: 'Pipeline Value', value: `$${Number(stats.pipeline_value).toLocaleString()}`, color: 'rose' },
        { title: 'Monthly Expenses', value: `$${Number(stats.monthly_expenses).toLocaleString()}`, color: 'red' },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
            {cards.map((stat, i) => (
                <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">{stat.title}</p>
                    <p className="text-2xl font-black text-gray-800 mt-2">{stat.value}</p>
                </div>
            ))}
        </div>
    );
};

export default DashboardStats;
